import * as moment from 'moment';

export const getDateTimeIST = (isoDateString: string) => {
    const isoDate = new Date(isoDateString);
    const options: any = {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        fractionalSecondDigits: 3
    };

    return isoDate.toLocaleDateString("en-IN", options);
}

export const getIsoDate = (date: any) => {
    return (date && date !== '')  ? new Date(date).toISOString() : ''
}

export const copyToClipboard = (row: any) => {
    // Convert the object to a JSON string
    const jsonString = JSON.stringify(row, null, 2); // Use null and 2 for pretty formatting

    // Use the Clipboard API to write the JSON string to the clipboard
    navigator.clipboard.writeText(jsonString)
      .catch((error) => {
        console.error('Unable to copy row: ', error);
      });
  }

export const setDateFormat = (date: string) => {
    const localDate = moment(date).set({ hour: 12, minute: 1, second: 0, millisecond: 0 }).format('YYYY-MM-DDTHH:mm:ss.SSSZ');

    console.log('Local Date:', localDate);

    return localDate;
}

export const getDate = (date: any): string => {
    const currentDate = new Date(date);

    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(currentDate.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export const formatDate = (dateStr: string) => {
  return dateStr?.split("T")[0]?.split("-")?.reverse()?.join("/") || "";
};